import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import axios from "axios";
import { backendUrl } from "../utils/urlHelper";

const EnquiryStats = () => {
  const [enquiryStats, setEnquiryStats] = useState({
    totalAcademicYear: 0,
    last30Days: 0,
    last7Days: 0,
    today: 0,
  });
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : {};

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const response = await axios.get(backendUrl + "/api/enquiries/stats", {
        headers: { Authorization: token },
      });
      setEnquiryStats(response.data);
    } catch (error) {
      console.error("Failed to fetch stats:");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {/* Stats Section */}
      {/* Loader */}
      {loading && (
        <Typography textAlign="center" variant="body1">
          Loading enquiries...
        </Typography>
      )}
      <Box>
        <Typography variant="h6" sx={{ my: 2 }}>
          {user.role === "admin"
            ? "All Enquiries Summary"
            : "Your Enquiries Summary"}
        </Typography>
        <Grid container spacing={3}>
          {Object.entries(enquiryStats).map(([key, value]) => (
            <Grid item xs={12} sm={6} md={3} key={key}>
              <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h6" textAlign="center">
                    {key === "totalAcademicYear"
                      ? "Academic Year"
                      : key === "last30Days"
                      ? "Last 30 Days"
                      : key === "last7Days"
                      ? "Last 7 Days"
                      : "Today"}
                  </Typography>
                  <Typography variant="h4" color="primary" textAlign="center">
                    {value}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default EnquiryStats;
